<template>
    <div class="html-text" v-html="sanitized"></div>
</template>

<script setup lang="ts">

  import DOMPurify from 'dompurify';
  import {computed, toRefs} from "vue";

  const props = withDefaults(defineProps<{
    value: string | undefined | null,
    }>(), {
  });
  const {
    value,
  } = toRefs(props);

  const sanitized = computed(() => {
    return DOMPurify.sanitize(value.value);
  });

</script>

<style scoped lang="scss">

.html-text {
  white-space: pre-wrap;

  > :first-child {
    margin-top:0px !important;
  }
}

</style>